import React from 'react';
import { Select } from 'antd';

import { LeadModel } from '@/typings/models/Lead';
import classNames from 'classnames';
import styles from '@/components/Lead/index.less';
import LeadDropdownFilter from '@/components/Filters/LeadDropdownFilter';
import { F } from '@/utils/intl';
import { useDispatch, useIntl } from 'umi';

const { Option } = Select;

// Fixed set of salutation options

const getLeadSalutation = (lead: LeadModel) => lead?.customer?.salutation;

const LeadSalutation = ({lead, readonly, isTable, value, onChange, ...props}: {
  isTable?: boolean,
  lead: LeadModel,
  readonly?: boolean,
  isCustomer?: boolean,
  value?: string,
  onChange: (salutation: string) => void
}) => {
  const leadSalutation = getLeadSalutation(lead) || value;
  const dispatch = useDispatch()
  const intl = useIntl()

  const SALUTATION_OPTIONS = [
    {
      value: 'm',
      label: intl.formatMessage({
        id: 'customer.gender.mr',
        defaultMessage: 'Mr.',
      }),
    },
    {
      value: 'f',
      label: intl.formatMessage({
        id: 'customer.gender.ms',
        defaultMessage: 'Ms.',
      }),
    },
    {
      value: 'd',
      label: intl.formatMessage({
        id: 'customer.gender.notSpecified',
        defaultMessage: 'Not Specified',
      }),
    },
  ];


  // Find the label for display
  const salutationOption = SALUTATION_OPTIONS.find(opt => opt.value === leadSalutation);
  const representation = salutationOption ? <F id={salutationOption.label} /> : ' - ';

  const onChangeSalutation = (newSalutation) => {
    const value = newSalutation?.value || newSalutation
    if (lead) {
      dispatch({
        type: 'leads/edit',
        payload: {
          'customer.gender': value,
          leadId: lead.id,
        },
      });
    }
    onChange && onChange(value)
  };

  // For read-only display
  if (readonly || (!lead && !onChange)) {
    return (
      <span className={classNames(styles.leadSalutation, {
        [styles.leadSalutationTable]: isTable,
      })}>
        {representation}
      </span>
    );
  }

  return (
    <LeadDropdownFilter
      filterKey={'customer.gender'}
      value={leadSalutation}
      placeholder={
        <F id={'customer.salutation'} defaultMessage={'Salutation'} />
      }
      options={SALUTATION_OPTIONS}
      onChange={onChangeSalutation}
      filterMode={'select'}
      className={classNames(styles.leadSalutationContainer, {
        [styles.leadSalutationTable]: isTable,
      })}
      {...props}
      selectProps={{
        bordered: false,
        allowClear: false,
        size: isTable ? 'medium' : 'small',
        ...(props?.selectProps || {}),
      }}
    />
  );
};

export default LeadSalutation;
